module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner1.5ef03ea1.jpg";